(function ($) {
  // Map animation
  fetch("assets/images/map.svg")
    .then((response) => response.text())
    .then((svg) => {
      const svgContainer = document.getElementById("svg-map-container");

      if (svgContainer === null) {
        return;
      }

      svgContainer.innerHTML = svg;
      initializeAnimation();
    })
    .catch((error) => console.error("Error loading SVG:", error));

  function initializeAnimation() {
    var forEach = function (array, callback, scope) {
      for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
      }
    };

    var randomIntFromInterval = function (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    };

    var $mapPins = document.querySelectorAll("#Map-shape g");

    forEach($mapPins, function (index, value) {
      value.groupTimeline = new TimelineMax({
        paused: true,
      });

      value.groupTimeline.to(value, 0.25, {
        opacity: 0,
      });

      // Pulse animation
      var pinTimeline = new TimelineMax({
        repeat: -1,
        delay: randomIntFromInterval(1, 3),
        repeatDelay: randomIntFromInterval(0, 1),
      });

      pinTimeline.to(value.querySelector(".Pin-back"), 3, {
        scale: 50,
        transformOrigin: "center center",
        opacity: 0,
      });
    });
  }

  // Wave animation
  fetch("assets/images/waves.svg?v=1")
    .then((response) => response.text())
    .then((svg) => {
      const svgContainer = document.getElementById("svg-wave-container");

      if (svgContainer === null) {
        return;
      }

      svgContainer.innerHTML = svg;
    })
    .catch((error) => console.error("Error loading SVG:", error));

  // Curve animation
  fetch("assets/images/curve.svg")
    .then((response) => response.text())
    .then((svg) => {
      const svgContainer = document.getElementById("svg-curve-container");

      if (svgContainer === null) {
        return;
      }

      svgContainer.innerHTML = svg;

      initializeCurveAnimation();
    })
    .catch((error) => console.error("Error loading SVG:", error));

  function initializeCurveAnimation() {
    var $curve = document.getElementById("curve");
    var last_known_scroll_position = 0;
    var defaultCurveValue = 150;
    var curveRate = 1;
    var ticking = false;
    var curveValue;

    function scrollEvent(scrollPos) {
      if (scrollPos >= 0 && scrollPos < defaultCurveValue) {
        curveValue = defaultCurveValue - parseFloat(scrollPos / curveRate);
        $curve.setAttribute(
          "d",
          "M 800 100 Q 400 " + curveValue + " 0 100 L 0 0 L 800 0 L 800 300 Z"
        );
      }
    }

    window.addEventListener("scroll", function (e) {
      last_known_scroll_position = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          scrollEvent(last_known_scroll_position);
          ticking = false;
        });
      }
      ticking = true;
    });
  }
})(jQuery);
